import React, { useState, useEffect, useLayoutEffect,  useRef, useContext } from 'react';
import { GlobalContext } from 'context/userContext';
import { Grid } from '@mui/material';
import { DrawerHeader } from '@components/drawer-header';
import TableExplorer from '@components/table-explorer/table_explorer';
import Paper from '@mui/material/Paper';
import { AxiosInstanceLongTimeOut } from '@service/axios-instance';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Modal, Typography, FormLabel, Switch, FormControlLabel, FormHelperText, useTheme, TextField, Autocomplete } from '@mui/material';

import * as S from './styles';


export function RemoteBlocking() {

  const { operation }   = useContext(GlobalContext);
  const { equipament }  = useContext(GlobalContext);
  const { startDate }   = useContext(GlobalContext);
  const { endDate }     = useContext(GlobalContext);

  const [editModalOpen, seteditModalOpen] = useState<boolean>(false);
  const [resetModalOpen, setResetModalOpen] = useState<boolean>(false);
  const [maintenanceModalOpen, setMaintenanceModalOpen] = useState<boolean>(false);
  const [toBlock, setToBlock] = useState<boolean>(false);
  const [clickedRowData, setClickedRowData] = useState<any[] |null>(null);
  const [equipmentsList, setEquipmentsList] = useState<any[]>([]);

  const [table1, setTable1] = useState<any>(null);
  const [table2, setTable2] = useState<any>(null);
  const [table3, setTable3] = useState<any>(null);
  const [table4, setTable4] = useState<any>(null);

  useEffect(() => {
    if (!operation) return;
    AxiosInstanceLongTimeOut.post(`/equipaments/get_equipaments?db=${operation}`, {}, {
      withCredentials: true,
    })
      .then((res) => {
        if (res.data) {
          setEquipmentsList(res.data);
        }
      })
      .catch(console.error);
  }, [operation]);

  const handleGlobalSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (table1) table1.search(val).draw();
    if (table2) table2.search(val).draw();
    if (table3) table3.search(val).draw();
    if (table4) table4.search(val).draw();
  };
  function row_block_open_cb(row_instance: Record<string, any>){
    setToBlock(true)
    setClickedRowData(row_instance.data());
    seteditModalOpen(true);
  }


  function row_unblock_open_cb(row_instance: Record<string, any>){
    setToBlock(false)
    setClickedRowData(row_instance.data());
    seteditModalOpen(true);
  }

  function row_reset_checklist_cb(row_instance: Record<string, any>){
    setClickedRowData(row_instance.data());
    setResetModalOpen(true);
  }

  function row_maintenance_cb(row_instance: Record<string, any>){
    setClickedRowData(row_instance.data());
    setMaintenanceModalOpen(true);
  }

  const theme = useTheme();

  return (
    
    <DrawerHeader
      title={"Bloqueio Remoto"}
    >

      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Paper
            elevation={2}
            sx={{
              p: { xs: 2.5, md: 3 },
              bgcolor: 'background.paper',
              borderLeft: `6px solid ${theme.palette.primary.main}`,
              borderRadius: 2,
              mb: 1
            }}
          >
            <Box>
              <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: 1.5, fontWeight: 600 }}>
                AÇÃO CORRETIVA
              </Typography>
              <Typography variant="h4" fontFamily="Saira" fontWeight={900} color="text.primary">Bloqueio Remoto</Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                Restrinja a partida de equipamentos por motivos de manutenção, segurança ou inatividade. Clique na máquina desejada para bloquear ou desbloquear o uso imediatamente.
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Grid container justifyContent="center" sx={{ mb: 2 }}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Busca Máquina"
            variant="outlined"
            onChange={handleGlobalSearch}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 0, ml: 0 }}>
        <Grid xs={12}>
          <Paper elevation={5} style={{padding: "10px 20px 10px 20px", width:"100%", height:"100%"}}>
            <h2>Máquinas Bloqueadas por Manutenção</h2>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", mb: 3 }}>
              <Typography variant="subtitle1" fontWeight={700}>
                Alternar Modo de Manutenção
              </Typography>
              <Autocomplete
                options={equipmentsList}
                getOptionLabel={(option) => option.id ? `${option.id} (${option.tipo})` : ""}
                onChange={(e, value) => {
                  if (value) {
                    setClickedRowData([value.id, value.tipo, value.setor]);
                    setMaintenanceModalOpen(true);
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Selecione a Máquina para Manutenção" variant="outlined" size="small" />
                )}
              />
            </Box>
            <TableExplorer dbName={operation} tableName={"equipaments"} modifier_cb={row_maintenance_cb} startDate={""} endDate={""} match_filters_dict={{"last_state": 7}} visibleColumns={["id", "tipo", "setor"]} set_table_instance_cb={setTable4} hideColumnFilters={true} />
          </Paper>
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 2, ml: 0 }}>
        <Grid xs={12}>
          <Paper elevation={5} style={{padding: "10px 20px 10px 20px", width:"100%", height:"100%"}}>
            <h2>Máquinas Bloqueadas por Checklist Reprovado</h2>
            <TableExplorer dbName={operation} tableName={"equipaments"} modifier_cb={row_reset_checklist_cb} startDate={""} endDate={""} match_filters_dict={{"last_state":3}} visibleColumns={["id", "tipo", "setor"]} set_table_instance_cb={setTable3} hideColumnFilters={true} />
          </Paper>
        </Grid>
      </Grid>

      <Grid container spacing={2}  sx={{ mt: 2, ml: 0 }}>
        <Grid xs={5.5}>
          <Paper elevation={5} style={{padding: "10px 20px 10px 20px", width:"100%", height:"100%"}}>
            <h2>Máquinas Liberadas</h2>
            <TableExplorer dbName={operation} tableName={"equipaments"} modifier_cb={row_block_open_cb} startDate={""} endDate={""} match_filters_dict={{"bloqueio_remoto":0}} visibleColumns={["id", "tipo", "setor"]} set_table_instance_cb={setTable1} hideColumnFilters={true} />
          </Paper>
        </Grid>

        <Grid xs={1}></Grid>
        
        <Grid xs={5.5}>
          <Paper elevation={5} style={{padding: "10px 20px 10px 20px", width:"100%", height:"100%"}}>
            <h2>Máquinas Bloqueadas</h2>
            <TableExplorer dbName={operation} tableName={"equipaments"} modifier_cb={row_unblock_open_cb} startDate={""} endDate={""} match_filters_dict={{"bloqueio_remoto":1}} visibleColumns={["id", "tipo", "setor"]} set_table_instance_cb={setTable2} hideColumnFilters={true} />
          </Paper>
        </Grid>
      </Grid>


      {editModalOpen && (
        <Modal open={editModalOpen} onClose={() => seteditModalOpen(false)}>

          <S.ModalContainer>

            <Box sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                zIndex: 10,
              }}>
              <IconButton 
                onClick={() => seteditModalOpen(false)} 
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                width: '100%',
                maxWidth: 300,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography
                variant="h5"
                color="primary"
                fontWeight={600}
                textAlign="center"
              >
                {toBlock ? 'Bloqueio Remoto' : 'Desbloqueio Remoto'}
              </Typography>

              <p>Confirma o {toBlock? "Bloqueio": "Desbloqueio"} da máquina</p>
            
              <p>ID: <b>{clickedRowData?.[0]}</b></p>
              <p>Tipo: <b>{clickedRowData?.[1]}</b></p>
              <p>Setor: <b>{clickedRowData?.[2]}</b></p>
              
              <S.ButtonYes onClick={async () => 
                {
                  try {
                    const requestURL = `/equipaments/block_unblock_equipaments?db=${operation}`;

                    try {
                      console.log("calling the url");

                      const response = await AxiosInstanceLongTimeOut.post(
                        requestURL,
                        { id: clickedRowData?.[0], blocked: toBlock? 1:0  },
                        { withCredentials: true }
                      );
                      console.log("Saved!", response.data);
                      window.location.reload();
                      
                    } catch (err) {
                      console.error("Save error", err);
                      throw err;
                    }

                    seteditModalOpen(false);
                  } catch (err) {
                    alert("Erro ao fazer modificacao.");
                  }

                } }>
                SIM
              </S.ButtonYes>

              <S.ButtonNo onClick={()=>{seteditModalOpen(false);}}>
                NÃO
              </S.ButtonNo>

            </Box>
          </S.ModalContainer>
        </Modal>
      )}

      {resetModalOpen && (
        <Modal open={resetModalOpen} onClose={() => setResetModalOpen(false)}>
          <S.ModalContainer>
            <Box sx={{ position: 'absolute', top: 8, right: 8, zIndex: 10 }}>
              <IconButton onClick={() => setResetModalOpen(false)}><CloseIcon /></IconButton>
            </Box>
            <Box sx={{ width: '100%', maxWidth: 350, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h5" color="warning.main" fontWeight={600} textAlign="center">
                Forçar Reset do Checklist
              </Typography>
              <p>Confirma o envio do comando de reset para esta máquina? O bloqueio por checklist será limpo.</p>
              <p>ID: <b>{clickedRowData?.[0]}</b></p>
              <p>Tipo: <b>{clickedRowData?.[1]}</b></p>
              <p>Setor: <b>{clickedRowData?.[2]}</b></p>
              
              <S.ButtonYes onClick={async () => {
                  try {
                    const requestURL = `/equipaments/reset_checklist_equipament?db=${operation}`;
                    await AxiosInstanceLongTimeOut.post(
                      requestURL,
                      { id: clickedRowData?.[0] },
                      { withCredentials: true }
                    );
                    alert("Comando de reset enviado! O equipamento receberá na próxima comunicação.");
                    window.location.reload();
                  } catch (err) {
                    console.error("Save error", err);
                    alert("Erro ao enviar comando de reset.");
                  }
                  setResetModalOpen(false);
                }}>
                SIM, RESETAR
              </S.ButtonYes>
              <S.ButtonNo onClick={() => setResetModalOpen(false)}>
                NÃO
              </S.ButtonNo>
            </Box>
          </S.ModalContainer>
        </Modal>
      )}

      {maintenanceModalOpen && (
        <Modal open={maintenanceModalOpen} onClose={() => setMaintenanceModalOpen(false)}>
          <S.ModalContainer>
            <Box sx={{ position: 'absolute', top: 8, right: 8, zIndex: 10 }}>
              <IconButton onClick={() => setMaintenanceModalOpen(false)}><CloseIcon /></IconButton>
            </Box>
            <Box sx={{ width: '100%', maxWidth: 350, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h5" color="primary" fontWeight={600} textAlign="center">
                Alternar Manutenção
              </Typography>
              <p>Confirma a alteração do estado de manutenção da máquina?</p>
              <p>ID: <b>{clickedRowData?.[0]}</b></p>
              <p>Tipo: <b>{clickedRowData?.[1]}</b></p>
              <p>Setor: <b>{clickedRowData?.[2]}</b></p>
              
              <S.ButtonYes onClick={async () => {
                  try {
                    const requestURL = `/equipaments/toggle_maintenance_equipament?db=${operation}`;
                    await AxiosInstanceLongTimeOut.post(
                      requestURL,
                      { id: clickedRowData?.[0] },
                      { withCredentials: true }
                    );
                    alert("Comando de manutenção enviado! O equipamento receberá na próxima comunicação.");
                    window.location.reload();
                  } catch (err) {
                    console.error("Save error", err);
                    alert("Erro ao enviar comando de manutenção.");
                  }
                  setMaintenanceModalOpen(false);
                }}>
                SIM, ALTERNAR
              </S.ButtonYes>
              <S.ButtonNo onClick={() => setMaintenanceModalOpen(false)}>
                NÃO
              </S.ButtonNo>
            </Box>
          </S.ModalContainer>
        </Modal>
      )}
      
    </DrawerHeader>
  );
}

